import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../api.js'
import { Card, Field, Alert } from '../lib.jsx'

export default function Organizations() {
  const nav = useNavigate()
  const [orgs, setOrgs] = useState([])
  const [name, setName] = useState('')
  const [slug, setSlug] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  const load = () => api.organizations().then(setOrgs).catch(e => setErr(e.message))
  useEffect(() => { load() }, [])

  const create = async (e) => {
    e.preventDefault()
    setErr(''); setBusy(true)
    try { const org = await api.createOrganization({ name, slug }); setName(''); setSlug(''); load(); nav(`/organizations/${org.id}`) }
    catch (e) { setErr(e.message) } finally { setBusy(false) }
  }

  return (
    <>
      <div className="topbar">
        <div><h1>Organizacje</h1><div className="sub">Zespoły i wspólne zarządzanie dostępem.</div></div>
      </div>
      <div className="content">
        <div className="grid grid-2" style={{ alignItems: 'start' }}>
          <Card title="Utwórz nową organizację">
            <form onSubmit={create}>
              <Alert kind="err">{err}</Alert>
              <Field label="Nazwa"><input value={name} onChange={e => setName(e.target.value)} required /></Field>
              <Field label="Slug" hint="Unikalny identyfikator, np. moja-firma"><input value={slug} onChange={e => setSlug(e.target.value.trim().toLowerCase())} required /></Field>
              <button className="btn btn-primary" disabled={busy || !name || !slug}>{busy ? 'Tworzenie…' : 'Utwórz organizację'}</button>
            </form>
          </Card>

          <Card title="Twoje organizacje" desc={`${orgs.length} łącznie`}>
            {orgs.length === 0 ? <div className="empty">Nie należysz jeszcze do żadnej organizacji.</div> : (
              orgs.map(o => (
                <div key={o.id} className="unit-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                  onClick={() => nav(`/organizations/${o.id}`)}>
                  <span><b>{o.name}</b> <span className="muted small">{o.slug}</span></span>
                  <span className="muted small">Otwórz ›</span>
                </div>
              ))
            )}
          </Card>
        </div>
      </div>
    </>
  )
}
